export const PREFIX = 'tv3'
export const ADMIN_MASQUERADE_FLAG_KEY = 'is_from_masquerade'
export const USER_FROM_TV3_FLAG_KEY = 'is_user_from_tv3'
export const IGNORE_AUTO_RESPONSE_FLAG_KEY = 'is_ignore_auto_response'
